import { useCallback } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useQueryClient } from "@tanstack/react-query";

import { adminSettingLogoSchemas } from "../../../../schemas/adminSettingPage";
import useMutate from "../../../../hooks/useMutate";
import { updateTenantLogos } from "../../../../services/apiSystemSettings";

export function useLogoForm() {
  const queryClient = useQueryClient();
  const methods = useForm({
    resolver: yupResolver(adminSettingLogoSchemas),
  });
  const { mutate, isPending } = useMutate(
    updateTenantLogos,
    ["logo"],
    () => {},
    () => {
      methods.reset();
      queryClient.invalidateQueries({
        queryKey: ["logo"],
      });
    }
  );
  const formValues = methods.watch();

  const isFieldFilled = useCallback(
    (name) => {
      return (
        formValues[name] !== undefined &&
        formValues[name] !== "" &&
        formValues[name] !== null
      );
    },
    [formValues]
  );

  const handleSubmit = useCallback(
    (formData) => {
      mutate(formData);
    },
    [mutate]
  );

  return {
    methods,
    isPending,
    isFieldFilled,
    handleSubmit,
  };
}
